module.exports = __webpack_public_path__ + "img/vi.329d1030.png";